// 2020-06-27export { MyColSwitchComponent } from './my-col-switch.component';